import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import styles from './async-image.module.scss';

class AsyncImage extends Component {
  constructor() {
    super();

    this.state = {
      loaded: false,
      shown: false
    };

    this.onEntered = this.onEntered.bind(this);
  }

  componentDidMount() {
    const img = new Image();

    img.addEventListener('load', () => {
      this.setState({ loaded: true });
    });

    img.src = this.props.src;
  }

  onEntered() {
    this.props.onEntered && this.props.onEntered();
    this.setState({ shown: true });
  }

  render() {
    const { alt, src, placeholder, timeout, ...rest } = this.props;

    return (
      <div className={styles.container}>
        {!this.state.shown && (
          <div className={styles.image} data-test-id="placeholder-image">
            <img src={placeholder} alt={alt} {...rest} />
          </div>
        )}

        <CSSTransition
          classNames={{
            enter: styles.enter,
            enterActive: styles.enterActive,
            enterDone: styles.enterDone,
            exit: styles.exit,
            exitActive: styles.exitActive
          }}
          in={this.state.loaded}
          timeout={timeout}
          onEntered={this.onEntered}
          key="full"
        >
          <div className={classnames(styles.image, styles.full)}>
            <img src={src} alt={alt} {...rest} />
          </div>
        </CSSTransition>
      </div>
    );
  }
}

AsyncImage.defaultProps = {
  timeout: 500
};

AsyncImage.propTypes = {
  placeholder: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  timeout: PropTypes.number,
  onEntered: PropTypes.func
};

export default AsyncImage;
